import React from "react";
import {Modal} from "react-bootstrap";

interface Props {
    isShow: boolean;
    setShow: (eulaShow: boolean) => void;
}
const AgreePromotionModal: React.FC<Props> = (props) => {
    return (
        <Modal
            size="lg"
            show={props.isShow}
            onHide={() => props.setShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                    Email newsletters
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                We may provide you with promotional information, such as announcements, special benefits, and recommendations related to services by CBM Interactive. You may choose not to agree to receive Email newsletters; even if you agree, you may withdraw your agreement at any time.
            </Modal.Body>
        </Modal>
    );
}

export default AgreePromotionModal;